<template>
  <div>
    <v-card class="elevation-0 transparent mx-auto" max-width="500">
      <v-layout wrap ml-1 mt-6>
        <v-flex xs12>
          <h1 :style="`color: ${$vuetify.theme.primary}`">{{_tripForm.eventName}}</h1>
          <h3>{{rightDate}}</h3>
          <br />
          <v-divider></v-divider>
          <h3 :style="getFontProperty()">{{$translate('LINDA_ARRIVAL_LABEL')}}:</h3>
          <h3>{{_tripForm.ArrivalTime}}</h3>
          <br />
          <h3 :style="getFontProperty()">{{$translate('LINDA_DEPARTURE_LABEL')}}:</h3>
          <h3>{{_tripForm.DepartureTime}}</h3>
          <br />
          <h3 :style="getFontProperty()">{{$translate('LINDA_TRANSPORT_TYPE')}}:</h3>
          <div v-if="_tripForm.transportName == 'Walking'">
            <h3>
              <v-icon>directions_walking</v-icon>
              {{_tripForm.transportName}}
            </h3>
          </div>
          <div v-if="_tripForm.transportName == 'Bicycle'">
            <h3>
              <v-icon>directions_bike</v-icon>
              {{_tripForm.transportName}}
            </h3>
          </div>
          <div v-if="_tripForm.transportName == 'Car'">
            <h3>
              <v-icon>directions_car</v-icon>
              {{_tripForm.transportName}}
            </h3>
          </div>
          <div v-if="_tripForm.transportName == 'Public transport'">
            <h3>
              <v-icon>train</v-icon>
              {{_tripForm.transportName}}
            </h3>
          </div>
          <div v-if="_tripForm.transportName == 'Shuttle bus'">
            <h3>
              <v-icon>directions_bus</v-icon>
              {{_tripForm.transportName}}
            </h3>
          </div>
          <div v-if="_tripForm.transportName == 'None'">
            <h3>Walking</h3>
          </div>
          <br />
          <v-divider></v-divider>
          <br />
          <h3 :style="getFontProperty()">{{$translate('LINDA_ORDER')}}:</h3>
          <div class>
            <template>
              <v-layout row>
                <v-flex xs12>
                  <v-card class="elevation-0 transparent">
                    <v-list two-line>
                      <template v-for="(item, index) in $store.getters.getUserTripOverview.orderList">
                        <v-list-tile v-if="item.GroupSize !== 0 || item.EventId !== 0 || item.Name !== 'Walking'"  :key="index" avatar ripple>
                          <v-list-tile-avatar>
                            <img :src="item.Picture" />
                          </v-list-tile-avatar>

                          <v-list-tile-content>
                            <v-list-tile-title>{{item.Name}}</v-list-tile-title>
                            <!-- <v-list-tile-sub-title>{{$translate('GROUP_SIZE')}}: {{item.GroupSize}} <br/> {{$translate('EVENT_PRICE')}}: € {{(item.TotalPrice / item.GroupSize).toFixed(2)}}  ||    {{$translate('TOTAL')}}: € {{(item.TotalPrice).toFixed(2)}}</v-list-tile-sub-title> -->
                            <v-list-tile-sub-title>{{$translate('TIME')}}: {{item.StartTime}} - {{item.EndTime}}</v-list-tile-sub-title>
                          </v-list-tile-content>

                          <v-list-tile v-if="!!item.Price">€{{item.Price}}</v-list-tile>

                          <v-list-tile>{{item.GroupSize}}x</v-list-tile>

                          <v-list-tile
                            v-if="!!item.TotalPrice"
                          >{{$translate('SUBTOTAL')}}: €{{item.TotalPrice}}</v-list-tile>

                          <v-list-tile v-if="!item.TotalPrice">
                            <v-tooltip top>
                              <template #activator="{ on }">
                                <v-icon color="grey lighten-1" v-on="on">info</v-icon>
                              </template>
                              <span>
                                <center><strong>Tickets are handled by the event organization.</strong></center>
                                <center>An entrance fee may be charged at the location.</center>
                              </span>
                            </v-tooltip>
                          </v-list-tile>
                        </v-list-tile>
                      </template>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </template>
          </div>
        </v-flex>
        <v-flex class="outlineLine mr-3">
          <v-divider></v-divider>
          <v-divider></v-divider>
        </v-flex>
        <v-flex xs12 sm12>
          <v-toolbar class="elevation-0 transparent mr-1">
            <v-spacer></v-spacer>
            <h3 v-if="!!_tripForm.totalPrice">{{$translate('TOTAL')}}: € {{_tripForm.totalPrice}}</h3>
          </v-toolbar>
        </v-flex>
      </v-layout>
    </v-card>
    <v-layout row justify-space-around>
      <v-btn
        round
        class="text-capitalize"
        color="secondary"
        @click="cancelOrder"
      >{{$translate('LINDA_CANCEL_ORDER')}}</v-btn>
      <v-btn
        round
        class="text-capitalize"
        color="primary"
        @click="confirmOrderLoading"
      >{{$translate('LINDA_CONFIRM_ORDER')}}</v-btn>
    </v-layout>

    <v-dialog v-model="showLoading" persistent max-width="390">
      <v-card class="confirmLoadingDialog">
        <v-layout column justify-center align-start>
          <v-card-title class="headline">Order info</v-card-title>
          <v-card-text>
            <p class="setFontSize" :style="getFontProperty()">Your order has been received.</p>
            <p
              class="setFontSize"
              v-if="_tripForm.totalPrice !== '0.00'"
              :style="getFontProperty()"
            >You will be automatically redirected to the payment page</p>
            <p
              v-else
              class="setFontSize"
              :style="getFontProperty()"
            >You will be automatically redirected to your appointments</p>
          </v-card-text>

          <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-layout>
      </v-card>
    </v-dialog>
     <div class="text-xs-center">
        <v-dialog
          width="500"
          persistent
          v-model="freeTripDialog"
        >
          <v-card>
            <v-card-title
              class="headline grey lighten-2"
              primary-title
            >
              Trip saved
            </v-card-title>
            <v-card-text>
              The trip is saved. Go to your trips to see all the details.
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                flat
                @click="goToTrip()"
              >
                Go to my trips
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
  </div>
</template>

<script>
import appConfig from "../../config/app_config.js";
import * as dssRequest from "../api/dssRequest";
import { mapGetters } from "vuex";
import { store } from "../store";
import TripOrderReady from "./TripOrderReady";
import BaseObject from "../objects/BaseObject";
import { ui_helpers } from "../shared/ui_helpers.js";

export default {
  mixins: [ui_helpers],
  name: "TripOrderOverview",

  computed: {
    ...mapGetters({
      _webStep: "getWebStepId",
      _tripForm: "getTripForm",
      language: "getLanguage"
    })
  },

  watch: {
    language: function(newV, oldV) {
      console.log("newV: ", newV);
      if (newV == "NL") {
        this.locale = "nl-NL";
      } else {
        this.locale = "en-GB";
      }
      this.rightDate = new Date(
        this._tripForm.date
          .split("-")
          .reverse()
          .join("-")
      ).toLocaleDateString(this.locale, this.options);
    }
  },

  components: {
    TripOrderReady
  },

  data: () => ({
    freeTripDialog: false,
    showLoading: false,
    responseData: [],
    paymentId: "",
    orderData: {},
    rightDate: null,
    options: {
      year: "numeric",
      month: "long",
      day: "numeric"
    },
    locale: "en-GB"
  }),

  mounted() {
    if(this._tripForm.totalPrice !== 0.00 ){
    }
    this.rightDate = new Date(
      this._tripForm.startDate
        .split("-")
        .reverse()
        .join("-")
    ).toLocaleDateString(this.locale, this.options);
    if (this._tripForm.ArrivalTime.charAt(2) !== ":") {
      this._tripForm.ArrivalTime =
        this._tripForm.ArrivalTime.slice(0, 2) +
        ":" +
        this._tripForm.ArrivalTime.slice(2, 4);
    }

    if (this._tripForm.DepartureTime.charAt(2) !== ":") {
      this._tripForm.DepartureTime =
        this._tripForm.DepartureTime.slice(0, 2) +
        ":" +
        this._tripForm.DepartureTime.slice(2, 4);
    }
  },
  methods: {
    goToTrip(){
      setTimeout(() => {
        this.confirmOrder();
      }, 100);
    },
    confirmOrderLoading() {
      if(this._tripForm.totalPrice !== 0.00){
      this.showLoading = true;
    }
    if(this._tripForm.totalPrice == 0.00){
      this.freeTripDialog = true;
      return
    }
      setTimeout(() => {
        this.confirmOrder();
      }, 10);
    },
    confirmOrder() {
      const payload = {
        Runtime: true,
        TripId: this._tripForm.tripId,
        OrderId: this._tripForm.orderId
      };
      dssRequest.doRequest(
        response => {
          console.log("The call for confirmOrder was successful", response);
          this.showLoading = false;
          if (
            response.data.hasOwnProperty("PaymentId") &&
            response.data.hasOwnProperty("PaymentUrl")
          ) {
            this.$store.commit("setTripFormPaymentId", response.data.PaymentId);
            if (this._tripForm.totalPrice !== "0.00") {
              const path = response.data.PaymentUrl;
              window.location = path;
            } else {
              this.goTo("MainEventInfo");
              this.$store.commit("setWebStepId", 2);
            }
          } else {
            console.log("confirmed tirp without paymet");
            this.goTo("UserTripList");
          }
        },
        error => {
          console.log("The call for confirmOrder was not successful", error);
          this._tripForm.mainEventId = null;
          this._tripForm.eventName = "";
          this._tripForm.locationId = "";
          this._tripForm.date = "";
          this._tripForm.groupSize = null;
          this._tripForm.ArrivalTime = "";
          this._tripForm.DepartureTime = "";
          this._tripForm.activityList = [];
          this._tripForm.transportId = null;
          this._tripForm.transportName = "";
          this._tripForm.paymentId = "";
          this._tripForm.activities = [];
          //this.goTo("Home");
          this.$store.commit("setWebStepId", 6);
        },
        "confirmOrder",
       this.$store.getters["auth/userName"],
        payload
      );
    },
    goTo(page) {
      // window.EventBus.showPage(page);
      this.$router.push({
        name: page,
        params: "component"
      });
    },
    cancelOrder() {
      this._tripForm.activities = [];
      this._tripForm.mainEventId = null;
      this._tripForm.eventName = "";
      this._tripForm.locationId = "";
      this._tripForm.date = "";
      this._tripForm.groupSize = null;
      this._tripForm.ArrivalTime = "";
      this._tripForm.DepartureTime = "";
      this._tripForm.activityList = [];
      this._tripForm.transportId = null;
      this._tripForm.transportName = "";
      this._tripForm.paymentId = "";

      const payload = {
        Runtime: true,
        TripId: this._tripForm.tripId,
        OrderId: this._tripForm.orderId,
        FunctionId: "EventFunctionLibrary::cancelOrder"
      };
      dssRequest.doRequest(
        response => {
          console.log("The call for cancelOrder was successful", response);
          this.$store.commit("setWebStepId", 1);
        },
        error => {
          console.log("The call for cancelOrder was not successful", error);
          this.$store.commit("setWebStepId", 1);
          this.$router.push({
            name: "Home",
            params: "component"
          });
        },
        "communicateWithDBLibrary",
        this.$store.getters["auth/userName"],
        payload
      );
    }
  }
};
</script>
<style>
.scrollableAuto {
  max-height: 18em !important;
  overflow-x: hidden;
  overflow-y: scroll;
}

.outlineLine {
  margin-top: -1em;
}

.textMain {
  margin-left: -1.5em;
  margin-top: 3em;
}

.textSub {
  margin-left: 15em;
  margin-top: -2.5em;
  font-size: 15px;
}

.setFontSize {
  font-size: 15px;
}

.confirmLoadingDialog {
  border-radius: 1em !important;
}
</style>
